// extracted by mini-css-extract-plugin
module.exports = {"audio":"Audio_audio__PkYx3","mobile":"Audio_mobile__uH318"};